<template>
  <div>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="经销商编码/名称" prop="agentCode">
                <el-input v-model="q.agentCode" placeholder="请输入经销商编码或名称"></el-input>
              </el-form-item>
              <!--              <el-form-item label="经销商名称" prop="agentName">
                              <el-input v-model="q.agentName" placeholder="请输入"></el-input>
                            </el-form-item>-->
              <el-form-item label="渠道" prop="channelCode">
                <brselect
                    category="fl_sales_region_main"
                    :v="q.channelCode"
                    v-model="q.channelCode"
                    :multiple="true"
                    :clearable="true"
                    @change="handleChannelChange"
                />
              </el-form-item>
              <el-form-item label="签约链群" prop="rebateChainGroup">
                <brselect
                    category="fl_25_chain_group"
                    :v="q.rebateChainGroup"
                    v-model="q.rebateChainGroup"
                    :multiple="true"
                    :clearable="true"
                    @change="handleChainGroupChange"
                />
              </el-form-item>
              <el-form-item label="返利归属产业" prop="belongIndustry">
                <brselect category="fl_belong_industry" :v="q.belongIndustry" v-model="q.belongIndustry" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="签约目标类别" prop="signTargetType">
                <brselect category="fl_sign_target_type" :v="q.signTargetType" v-model="q.signTargetType" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="是否销额" prop="isXiaoeQuery">
                <el-select v-model="q.isXiaoeQuery" placeholder="计入销额" clearable style="width: 120px">
                  <el-option label="计入销额" value="X"/>
                  <el-option label="不计销额" value="F"/>
                </el-select>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="状态" prop="channel">
                    <brselect category="fl_lvyue_quit_status" :v="q.isUse" v-model="q.isUse"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="区域" prop="area">
                    <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="经销商类型" prop="agentNameLike">
                    <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                  </el-form-item>
                </div>
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="所属链群" prop="contractId">
                    <brselect category="fl_contract_id" :v="q.contractId" v-model="q.contractId" :clearable="true"/>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  :summary-method="getSummaries"
                  show-summary
                  max-height="530"
        >
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域"
              width="80"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="agentType"
              :show-overflow-tooltip="true"
              label="经销商类型"
              width="80"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentType|dictname('fl_agent_type')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentCode"
              :show-overflow-tooltip="true"
              label="经销商编码"
              width="110"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentName"
              :show-overflow-tooltip="true"
              label="经销商名称"
              min-width="180"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="channel"
              :show-overflow-tooltip="true"
              label="渠道"
              width="120"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.channel || scope.row.channelCode || '' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              v-if="!showChannelColumn"
              prop="belongIndustry"
              :show-overflow-tooltip="true"
              label="返利归属产业"
              width="90"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ getBelongIndustryByChain(scope.row.rebateChainGroup) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              v-if="!showChannelColumn"
              prop="rebateChainGroup"
              :show-overflow-tooltip="true"
              label="签约链群"
              width="100"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.rebateChainGroup|dictname('fl_25_chain_group')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="1月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi1"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.janM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jan"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jan).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{ (Number(scope.row.janL).toFixed(2)) + '%' }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi2"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.febM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="feb"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.feb).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.febL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi3"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.marM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mar"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.mar).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.marL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="一季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="firstQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.firstQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi4"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.aprM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="apr"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.apr).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.aprL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi5"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi5).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.mayM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="may"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.may).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.mayL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="6月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi6"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi6).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.junM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jun"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jun).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.junL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="二季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="secondQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.secondQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi7"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi7).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.julM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jul"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jul).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.julL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="8月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi8"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi8).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.augM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aug"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.aug).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.augL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="9月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi9"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi9).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sepM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sep"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sep).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.sepL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="三季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="thirdQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.thirdQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi10"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi10).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.octM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="oct"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.oct).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.octL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="11月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi11"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi11).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.novM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="nov"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.nov).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.novL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="12月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi12"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi12).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.deceM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="dece"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.dece).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.deceL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="四季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="fourthQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.fourthQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="全年合计" :show-overflow-tooltip="true">
            <el-table-column
                prop="yearT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearS"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearS).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.yearL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
              prop="isUse"
              :show-overflow-tooltip="true"
              label="状态"
              width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.isUse | dictname('fl_lvyue_quit_status')}}
              </div>
            </template>
          </el-table-column>
          <!-- 审批状态 -->
          <el-table-column
              prop="planStatus"
              :show-overflow-tooltip="true"
              label="审批状态"
              width="100"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.planStatus }}
              </div>
            </template>
          </el-table-column>
          <!-- 签约目标类别 -->
          <el-table-column
              prop="signTargetType"
              :show-overflow-tooltip="true"
              label="签约目标类别"
              width="70"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.signTargetType | dictname('fl_sign_target_type') }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
            <!--            <el-button class="h-btn h-formBtn h-bgblueQ"
                                   @click="rollbackGoalImportToPingtai">回退至平台节点
                        </el-button>-->
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        isIncrement: 1,
        agentName: '',
        agentCode: '',
        channel: null,
        channelCode: null,
        rebateChainGroup: null,
        belongIndustry: null,
        signTargetType: [1, 3], // 默认值：1-续签，3-新开
        year: 2025,
        type: '',
        areaCode: null,
        isUse:'',
        isXiaoeQuery: 'X', // 是否销额：X-计入销额，F-不计销额，默认X
        isHouhongQuery: 'F', // 是否展示厚宏：T-展示（默认），F-不展示
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
      countlist:'',
      // 控制列显示：true表示选择了渠道筛选，需要隐藏返利归属产业和签约链群列
      showChannelColumn: false, // 是否选择了渠道筛选
      // 内部联动重置时用于避免 watch 反向触发
      houhongResetting: false,
    }
  },
  computed: {
    // 判断是否选择了渠道
    hasChannelSelected() {
      return this.q.channelCode && (Array.isArray(this.q.channelCode) ? this.q.channelCode.length > 0 : this.q.channelCode !== null && this.q.channelCode !== '');
    },
    // 判断是否选择了签约链群
    hasChainGroupSelected() {
      return this.q.rebateChainGroup && (Array.isArray(this.q.rebateChainGroup) ? this.q.rebateChainGroup.length > 0 : this.q.rebateChainGroup !== null && this.q.rebateChainGroup !== '');
    }
  },
  watch: {
    // 监听渠道选择变化（作为备用处理，主要逻辑在change事件中）
    'q.channelCode'(newVal, oldVal) {
      // 如果渠道有值，确保签约链群被清空
      if (this.hasChannelSelected && this.hasChainGroupSelected) {
        this.$nextTick(() => {
          this.q.rebateChainGroup = null;
        });
      }
    },
    // 监听签约链群选择变化（作为备用处理，主要逻辑在change事件中）
    'q.rebateChainGroup'(newVal, oldVal) {
      // 如果签约链群有值，确保渠道被清空
      if (this.hasChainGroupSelected && this.hasChannelSelected) {
        this.$nextTick(() => {
          this.q.channelCode = null;
        });
      }
    },
  },
  created() {
    this.q = {
      isIncrement: 1,
      agentName: '',
      agentCode: '',
      channel: null,
      channelCode: null,
      rebateChainGroup: null,
      belongIndustry: null,
      signTargetType: [1, 3], // 默认值：1-续签，3-新开
      type: '',
      isUse:0,
      areaCode: null,
      isXiaoeQuery: 'X',
      isHouhongQuery: 'F',
      pageSize: 10,
      pageNo: 1,
      total: 0
    };
    this.q.agentCode = this.$route.query.agentCode || ''
    this.showChannelColumn = false; // 默认未选择渠道筛选
  },
  mounted() {
    // 在mounted中调用，确保DOM已渲染完成
    this.$nextTick(() => {
      this.handleFilter();
    });
  },
  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    // 处理渠道选择变化
    handleChannelChange(value) {
      // 只有在渠道真正有选中值时才处理联动
      if (this.hasChannelSelected && this.hasChainGroupSelected) {
        this.$message.warning({
          message: '渠道与签约链群不能同时选择，已自动清空签约链群',
          duration: 3000
        });
        this.$nextTick(() => {
          this.q.rebateChainGroup = null;
        });
      }
    },
    // 处理签约链群选择变化
    handleChainGroupChange(value) {
      // 只有在签约链群真正有选中值时才处理联动
      if (this.hasChainGroupSelected && this.hasChannelSelected) {
        this.$message.warning({
          message: '签约链群与渠道不能同时选择，已自动清空渠道',
          duration: 3000
        });
        this.$nextTick(() => {
          this.q.channelCode = null;
        });
      }
    },
    //检索
    handleFilter() {
      // 根据是否选择渠道来控制列的显示
      this.showChannelColumn = this.hasChannelSelected;
      // 切换筛选条件后，total 可能变小；强制回到第一页避免当前页码超出新总页数
      this.q.pageNo = 1;
      this.query();
      this.queryTotal();
    },
    //重置
    reset() {
      this.q = {
        isIncrement: 1,
        agentType: '',
        agentName: '',
        agentCode: '',
        channel: null,
        channelCode: null,
        rebateChainGroup: null,
        belongIndustry: null,
        signTargetType: [1, 3], // 默认值：1-续签，3-新开
        type: '',
        isUse: 0,
        areaCode: null,
        isXiaoeQuery: 'X', // 是否销额：X-计入销额，F-不计销额，默认X
        isHouhongQuery: 'T', // 是否展示厚宏：默认展示

        pageSize: 10,
        pageNo: 1,
        total: 0
      },
          this.showChannelColumn = false; // 重置后恢复默认状态
      this.handleFilter();
    },
    //查询table
    query() {
      // 根据是否选择渠道来控制列的显示
      this.showChannelColumn = this.hasChannelSelected;
      // 清理参数，只传递有效值
      const queryParams = this.cleanQueryParams(this.q);
      ss.fanli.getLy2026Page(queryParams).then(rd => {
        if (rd && rd.total !== undefined) {
          this.q.total = rd.total;
          this.tableData = rd.records || [];
        }
      }).catch(err => {
        console.error('查询数据失败:', err);
        this.tableData = [];
        this.q.total = 0;
      });
    },
    queryTotal() {
      // 清理参数，只传递有效值
      const queryParams = this.cleanQueryParams(this.q);
      ss.fanli.getLy2026Total(queryParams).then(rd => {
        if (rd) {
          this.countlist = rd;
        }
      }).catch(err => {
        console.error('查询汇总数据失败:', err);
        this.countlist = {};
      });

    },
    // 清理查询参数，移除空值和无效值
    cleanQueryParams(params) {
      const cleaned = {...params};

      // 特殊处理 signTargetType：转换为 signTargetTypeList 字段，确保数组中的值都是整数类型，符合后端 List<Integer> 要求
      if (cleaned.signTargetType) {
        let signTargetTypeList = null;
        if (Array.isArray(cleaned.signTargetType)) {
          // 将数组中的值转换为整数，并过滤掉无效值
          signTargetTypeList = cleaned.signTargetType
              .map(val => parseInt(val, 10))
              .filter(val => !isNaN(val) && val > 0);

          // 如果转换后数组为空，则不设置该字段
          if (signTargetTypeList.length === 0) {
            signTargetTypeList = null;
          }
        } else {
          // brselect 多选时 emit 的是逗号分隔字符串（如 "1,2,3"），需 split 后再逐项转整数
          const strVal = String(cleaned.signTargetType).trim();
          if (strVal) {
            signTargetTypeList = strVal.split(',')
                .map(s => parseInt(s.trim(), 10))
                .filter(v => !isNaN(v) && v > 0);
            if (signTargetTypeList.length === 0) {
              signTargetTypeList = null;
            }
          }
        }

        // 将处理后的值赋给 signTargetTypeList，并删除 signTargetType
        if (signTargetTypeList && signTargetTypeList.length > 0) {
          cleaned.signTargetTypeList = signTargetTypeList;
        }
        delete cleaned.signTargetType;
      } else {
        // 筛选签约目标类别为空时，默认传入 1、2、3
        cleaned.signTargetTypeList = [1, 2, 3];
      }

      // 清理其他空值
      Object.keys(cleaned).forEach(key => {
        const value = cleaned[key];
        if (value === null || value === undefined || value === '') {
          delete cleaned[key];
        }
        // 如果是空数组，也删除
        if (Array.isArray(value) && value.length === 0) {
          delete cleaned[key];
        }
      });
      return cleaned;
    },
    /**
     * 根据签约链群编码匹配返利归属产业
     * 映射关系：
     *  cdwdwdgj -> 超低温&低温&冻干机
     *  ymw      -> 疫苗网
     *  ypw      -> 数智医疗
     *  swaq/pyx/lxj -> 数智科研
     */
    getBelongIndustryByChain(rebateChainGroup) {
      if (!rebateChainGroup) {
        return '';
      }
      const map = {
        cdwdwdgj: '超低温&低温&冻干机',
        ND4: '疫苗网',
        ypw: '数智医疗',
        swaq: '数智科研',
        pyx: '数智科研',
        lxj: '数智科研',
      };
      const codes = Array.isArray(rebateChainGroup)
          ? rebateChainGroup
          : String(rebateChainGroup).split(',');
      const result = [];
      codes.forEach(code => {
        const key = String(code).trim();
        const name = map[key];
        if (name && !result.includes(name)) {
          result.push(name);
        }
      });
      return result.join(',');
    },
    //批量导出
    exportExcel() {
      // 清理参数，只传递有效值，与查询接口保持一致
      const queryParams = this.cleanQueryParams(this.q);
      updownfile.down("/api/swyl/v1/fl/flQudaoSalesVolume/downloadExcelLvyue2026", queryParams, "post", "data");
    },

    /**
     * 目标导入审批：回退到平台节点（临时功能）
     * 由于履约报表为汇总页，这里通过弹窗输入 instid 触发回退。
     */
    rollbackGoalImportToPingtai() {
      this.$prompt('请输入流程实例ID(instid)', '回退至平台节点', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: 'instid不能为空'
      }).then(({value}) => {
        return ss.fanli.rollbackGoalImportToPingtai(value).then(() => {
          this.$message.success('已发起回退至平台节点');
        });
      }).catch(() => {
        // 取消不提示
      });
    },
    //求和汇总
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      // 辅助函数：安全转换数字，如果为NaN则返回0
      const safeNumber = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
      };
      // 辅助函数：安全格式化数字，如果为NaN则返回'0.00'
      const safeFormat = (val) => {
        const num = safeNumber(val);
        return num.toFixed(2);
      };
      // 辅助函数：安全计算百分比，如果为NaN则返回'0.00%'
      const safePercent = (val, total) => {
        const num = safeNumber(val);
        const totalNum = safeNumber(total);
        if (totalNum === 0) return '0.00%';
        const percent = (num * 100 / totalNum);
        return isNaN(percent) ? '0.00%' : percent.toFixed(2) + '%';
      };
      // 统一根据列的 prop 来决定显示的合计，避免列显隐后错位
      const totalMap = this.countlist ? {
        // 1月
        tongqi1: () => safeFormat(this.countlist.tongqi1),
        janM: () => safeFormat(this.countlist.janM),
        jan: () => safeFormat(this.countlist.jan),
        janL: () => safePercent(this.countlist.jan, this.countlist.janM),
        // 2月
        tongqi2: () => safeFormat(this.countlist.tongqi2),
        febM: () => safeFormat(this.countlist.febM),
        feb: () => safeFormat(this.countlist.feb),
        febL: () => safePercent(this.countlist.feb, this.countlist.febM),
        // 3月
        tongqi3: () => safeFormat(this.countlist.tongqi3),
        marM: () => safeFormat(this.countlist.marM),
        mar: () => safeFormat(this.countlist.mar),
        marL: () => safePercent(this.countlist.mar, this.countlist.marM),
        // 一季度
        firstQuarterT: () => safeFormat(this.countlist.firstQuarterT),
        firstQuarterM: () => safeFormat(this.countlist.firstQuarterM),
        firstQuarter: () => safeFormat(this.countlist.firstQuarter),
        firstQuarterL: () => safePercent(this.countlist.firstQuarter, this.countlist.firstQuarterM),
        // 4月
        tongqi4: () => safeFormat(this.countlist.tongqi4),
        aprM: () => safeFormat(this.countlist.aprM),
        apr: () => safeFormat(this.countlist.apr),
        aprL: () => safePercent(this.countlist.apr, this.countlist.aprM),
        // 5月
        tongqi5: () => safeFormat(this.countlist.tongqi5),
        mayM: () => safeFormat(this.countlist.mayM),
        may: () => safeFormat(this.countlist.may),
        mayL: () => safePercent(this.countlist.may, this.countlist.mayM),
        // 6月
        tongqi6: () => safeFormat(this.countlist.tongqi6),
        junM: () => safeFormat(this.countlist.junM),
        jun: () => safeFormat(this.countlist.jun),
        junL: () => safePercent(this.countlist.jun, this.countlist.junM),
        // 二季度
        secondQuarterT: () => safeFormat(this.countlist.secondQuarterT),
        secondQuarterM: () => safeFormat(this.countlist.secondQuarterM),
        secondQuarter: () => safeFormat(this.countlist.secondQuarter),
        secondQuarterL: () => safePercent(this.countlist.secondQuarter, this.countlist.secondQuarterM),
        // 7月
        tongqi7: () => safeFormat(this.countlist.tongqi7),
        julM: () => safeFormat(this.countlist.julM),
        jul: () => safeFormat(this.countlist.jul),
        julL: () => safePercent(this.countlist.jul, this.countlist.julM),
        // 8月
        tongqi8: () => safeFormat(this.countlist.tongqi8),
        augM: () => safeFormat(this.countlist.augM),
        aug: () => safeFormat(this.countlist.aug),
        augL: () => safePercent(this.countlist.aug, this.countlist.augM),
        // 9月
        tongqi9: () => safeFormat(this.countlist.tongqi9),
        sepM: () => safeFormat(this.countlist.sepM),
        sep: () => safeFormat(this.countlist.sep),
        sepL: () => safePercent(this.countlist.sep, this.countlist.sepM),
        // 三季度
        thirdQuarterT: () => safeFormat(this.countlist.thirdQuarterT),
        thirdQuarterM: () => safeFormat(this.countlist.thirdQuarterM),
        thirdQuarter: () => safeFormat(this.countlist.thirdQuarter),
        thirdQuarterL: () => safePercent(this.countlist.thirdQuarter, this.countlist.thirdQuarterM),
        // 10月
        tongqi10: () => safeFormat(this.countlist.tongqi10),
        octM: () => safeFormat(this.countlist.octM),
        oct: () => safeFormat(this.countlist.oct),
        octL: () => safePercent(this.countlist.oct, this.countlist.octM),
        // 11月
        tongqi11: () => safeFormat(this.countlist.tongqi11),
        novM: () => safeFormat(this.countlist.novM),
        nov: () => safeFormat(this.countlist.nov),
        novL: () => safePercent(this.countlist.nov, this.countlist.novM),
        // 12月
        tongqi12: () => safeFormat(this.countlist.tongqi12),
        deceM: () => safeFormat(this.countlist.deceM),
        dece: () => safeFormat(this.countlist.dece),
        deceL: () => safePercent(this.countlist.dece, this.countlist.deceM),
        // 四季度
        fourthQuarterT: () => safeFormat(this.countlist.fourthQuarterT),
        fourthQuarterM: () => safeFormat(this.countlist.fourthQuarterM),
        fourthQuarter: () => safeFormat(this.countlist.fourthQuarter),
        fourthQuarterL: () => safePercent(this.countlist.fourthQuarter, this.countlist.fourthQuarterM),
        // 全年
        yearT: () => safeFormat(this.countlist.yearT),
        yearM: () => safeFormat(this.countlist.yearM),
        yearS: () => safeFormat(this.countlist.yearS),
        yearL: () => safePercent(this.countlist.yearS, this.countlist.yearM),
      } : {};

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        // 屏蔽前三个合计列
        if (index <= 3) {
          sums[index] = '';
          return;
        }
        const prop = column.property;

        // 屏蔽"状态"、"签约目标类别"、"渠道"和"审批状态"列的合计
        // 注意：页面“渠道”列的 prop 实际是 channel（不是 channelCode）
        if (prop === 'isUse' || prop === 'signTargetType' || prop === 'channelCode' || prop === 'channel' || prop === 'planStatus') {
          sums[index] = '';
          return;
        }

        // 优先使用后端汇总结果，保证列顺序变动后仍然对齐
        if (totalMap[prop]) {
          const result = totalMap[prop]();
          // 如果结果为NaN，置为'0.00'（对于数字）或'0.00%'（对于百分比）
          if (result && typeof result === 'string' && result.includes('%')) {
            sums[index] = isNaN(parseFloat(result)) ? '0.00%' : result;
          } else if (result && typeof result === 'string') {
            sums[index] = isNaN(parseFloat(result)) ? '0.00' : result;
          } else {
            sums[index] = result;
          }
          return;
        }

        // 没有后端汇总结果的列，使用前端简单求和
        const values = data.map(item => Number(item[prop]));
        if (!values.every(value => isNaN(value))) {
          const total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          // 如果合计结果为NaN，置为0
          const finalTotal = isNaN(total) ? 0 : total;
          sums[index] = Number(finalTotal).toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>
